/**
 * Knowledge Base Lot
 *
 * Platform knowledge base for feature guides, how-to articles,
 * workflows, and feature suggestions.
 */

// Main vehicles (UI components)
export { default as KnowledgeBaseDashboard } from './vehicles/KnowledgeBaseDashboard';
export { default as FeatureSuggestionPanel } from './vehicles/FeatureSuggestionPanel';

// Hooks
export { useKnowledgeBase } from './hooks/useKnowledgeBase';

// Service
export { KnowledgeBaseService } from './logic/KnowledgeBaseService';

// Category definitions
export const KB_CATEGORIES = {
  GETTING_STARTED: {
    id: 'getting-started',
    name: 'Getting Started',
    icon: 'Rocket',
    color: 'blue',
    description: 'New to ODV? Start here.'
  },
  FEATURES: {
    id: 'features',
    name: 'Features',
    icon: 'Sparkles',
    color: 'purple',
    description: 'Learn about platform features'
  },
  WORKFLOWS: {
    id: 'workflows',
    name: 'Workflows',
    icon: 'GitBranch',
    color: 'green',
    description: 'Step-by-step workflows'
  },
  HOW_TO: {
    id: 'how-to',
    name: 'How-To Guides',
    icon: 'BookOpen',
    color: 'amber',
    description: 'Detailed how-to articles'
  },
  TROUBLESHOOTING: {
    id: 'troubleshooting',
    name: 'Troubleshooting',
    icon: 'Wrench',
    color: 'red',
    description: 'Common issues and solutions'
  },
  VALETS: {
    id: 'valets',
    name: 'For Valets',
    icon: 'Car',
    color: 'teal',
    description: 'Valet-specific guides'
  },
  CLIENTS: {
    id: 'clients',
    name: 'For Clients',
    icon: 'Building2',
    color: 'indigo',
    description: 'Client portal guides'
  },
  ADMIN: {
    id: 'admin',
    name: 'Admin & KOT',
    icon: 'Shield',
    color: 'slate',
    description: 'Administration features'
  }
};

export const SUGGESTION_STATUS = {
  SUBMITTED: 'submitted',
  UNDER_REVIEW: 'under_review',
  PLANNED: 'planned',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  DECLINED: 'declined'
};

export const SUGGESTION_TYPES = {
  NEW_FEATURE: { id: 'new_feature', name: 'New Feature', icon: 'Plus' },
  IMPROVEMENT: { id: 'improvement', name: 'Improvement', icon: 'Sparkles' },
  BUG_FIX: { id: 'bug_fix', name: 'Bug Fix', icon: 'Bug' },
  UI_UX: { id: 'ui_ux', name: 'UI/UX', icon: 'Palette' },
  DOCUMENTATION: { id: 'documentation', name: 'Documentation', icon: 'BookOpen' }
};
